var exports = {
  "iE": "xaee3c4fa--687672--wrapper",
  "o5": "xaee3c4fa--687672--content-wrapper",
  "HE": "xaee3c4fa--687672--button-wrapper",
};

module.exports = exports;
